<template>
  <div class="welcome">
    <h2>U Lifestyle App 電子優惠商戶申請</h2>
    <div>
      <p>歡迎蒞臨U Lifestyle商戶中心！</p>
      <p>作為緊貼用戶生活的資訊性網絡平台，U Lifestyle掌握豐富的生活資訊，從本地娛樂、飲食、美容、旅遊等應有盡有，為用戶無限放送各種超強優惠！</p>
      <p>立即免費申請成為優惠商戶，把自家電子優惠發佈於U Lifestyle旗下網站及應用程式，龐大活躍用戶群將優惠帶給潛在客戶，助您增加店舖人流、網店流量，從而提升銷售！</p>
    </div>
    <div class="text-center">
      <b-button
        to="/signup"
        variant="primary"
        size="lg"
        @click="onSignUpBtnClicked($event)"
      >
        立即申請
      </b-button>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue';

export default {
  components: {
    BButton,
  },
  methods: {
    onSignUpBtnClicked(e) {
      console.log(e.target.href);
      // window.dataLayer.push({
      //   event: 'btnEventTrigger',
      //   ga4: {
      //     event_name: 'mc_apply_now',
      //     content: {
      //       id: 'NA',
      //       type: 'NA',
      //     },
      //     function: 'NA',
      //     text: 'NA',
      //     section: 'NA',
      //     service: 'merchant',
      //     category: 'NA',
      //     position: 'NA',
      //     screen: 'NA',
      //     reward: {
      //       id: 'NA',
      //       name: 'NA',
      //     },
      //     pageurl: window.location.href,
      //     clickurl: e.target.href,
      //     method: 'NA',
      //   },
      // });
    },
  },
  mounted() {
    this.$emit('updated');
  },
};
</script>

<style lang="scss">
.card--auth {
  max-width: 780px !important;
  border-radius: 10px;
}

</style>

<style scoped lang="scss">
.welcome {
  & h2 {
    color: #174169;
    font-size: 1.5rem;
    text-align: center;
    margin-bottom: 24px;
    line-height: 31px;
  }

  & p {
    color: #3a4047;
    font-weight: 400;
    font-size: 18px;
  }

  ::v-deep {
    .btn-lg{
    margin-top: 10px;
    font-size: 18px;
    padding: 16px 60px;
}

  }
}
</style>
